/**
 * Палитра из 30 цветов — единый локальный набор для пикеров (блоки БЗ,
 * папки Диска, выделения). Бренд-цвета первыми, дальше спектр. Хранится
 * у нас, без внешних CDN (решение юзера «храним у меня»).
 */
export const PALETTE_30: string[] = [
  '#251D4A', // brand indigo
  '#FF6900', // brand orange
  '#0096FF', // brand info
  '#E53935', // red
  '#FB8C00', // amber-orange
  '#E5A100', // yellow
  '#7CB342', // light green
  '#2E9E5B', // green
  '#00A6A6', // teal
  '#0F6FC0', // blue
  '#3F51B5', // indigo
  '#7E3FB8', // purple
  '#C2185B', // magenta
  '#D81B60', // pink
  '#6B7280', // gray
  '#8D6E63', // brown
  '#5C6BC0', // periwinkle
  '#26A69A', // teal-light
  '#66BB6A', // green-light
  '#9CCC65', // lime
  '#FFCA28', // gold
  '#FFA726', // orange-light
  '#FF7043', // deep orange
  '#EC407A', // rose
  '#AB47BC', // violet
  '#7986CB', // soft indigo
  '#4DD0E1', // cyan
  '#A1887F', // taupe
  '#90A4AE', // blue-gray
  '#455A64', // dark slate
];
